module.exports = __webpack_public_path__ + "static/media/  (31).d6c91e25.jpg";